import { Cancel } from '@material-ui/icons'
import { store } from 'index'
import { useEffect } from 'react'
import { useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { addLogMessage } from 'redux/actions/logActions'
import { resetLog } from 'redux/actions/logActions'
export const log = (msg, data = null) => {
    if (process.env.REACT_APP_SHOW_LOG) {
        let messageToLog = msg
        store.dispatch(addLogMessage(messageToLog))
        if (data) {
            store.dispatch(addLogMessage(JSON.stringify(data)))
        }
    }
    console.log(msg, data)
}
export default function DisplayLog() {
    const { logMessages } = useSelector(state => state.log)
    const dispatch = useDispatch()
    const targetRef = useRef()
    const displayLog = () => {
        return (
            <div
                style={{
                    width: '100vw', height: '30vh', border: '1px solid black',
                    flexDirection: 'column', position: 'fixed', left: 0,
                    bottom: '10vh',
                    backgroundColor: 'white',
                    zIndex: 10000
                }}>
                <Cancel onClick={() => dispatch(resetLog())}
                    style={{ fontSize: '2em', position: 'absolute', top: 0, right: 0 }} />
                <div ref={targetRef} style={{
                    overflowY: 'auto', marginTop: '2em', width: '100%', height: '25vh',
                    padding: '1em',
                    overscrollBehavior: 'contain'
                }}>
                    {logMessages.map((msg, ix) => <div key={ix}>{msg}</div>)}
                </div>
            </div>
        )

    }
    const scrollToBottom = () => {
        //console.log(`scrollToBottom`, targetRef)
        if (targetRef.current) {
            const scroll = targetRef.current.scrollHeight -
                targetRef.current.clientHeight
            targetRef.current.scrollTo(0, scroll)
        }
    }
    useEffect(() => {
        scrollToBottom()
    }, [logMessages])
    return displayLog()
}